/**
 * Champs fichier à un seul fichier du dépôt (formulaire 2) :
 * 46 = image de mise en avant, 26 = note d'intention, 38 = fichier de budget.
 *
 * Avec un maximum d'un fichier, Gravity Forms affiche l'alerte
 * « Nombre de fichiers maximal atteint » dès que le fichier est chargé.
 * On la transforme en confirmation, uniquement sur ces champs.
 */

const FIELD_SELECTOR = '#field_2_46, #field_2_26, #field_2_38';
const MESSAGE_SELECTOR = '.gfield_validation_message, .validation_message, [id^="gform_multifile_messages_"]';
const SUCCESS_TEXT = 'Fichier chargé';
const SUCCESS_CLASS = 'hf-file-loaded-notice';

const MAX_REACHED_SNIPPETS = [
    'nombre de fichiers maximal',
    'nombre maximum de fichiers',
    'maximum number of files',
    'max number of files',
];

/**
 * @param {string} text
 * @returns {boolean}
 */
function isMaxReachedMessage(text) {
    const normalized = text.trim().toLowerCase();

    return MAX_REACHED_SNIPPETS.some((snippet) => normalized.includes(snippet));
}

/**
 * @param {Node|null} node
 * @returns {HTMLElement|null}
 */
function messageFromNode(node) {
    if (!node) {
        return null;
    }

    const element = node.nodeType === Node.TEXT_NODE ? node.parentElement : node;

    if (!(element instanceof Element) || !element.closest(FIELD_SELECTOR)) {
        return null;
    }

    if (element.matches(MESSAGE_SELECTOR)) {
        return element;
    }

    return element.closest(MESSAGE_SELECTOR);
}

/**
 * @param {HTMLElement} message
 */
function rewriteMessage(message) {
    const text = (message.textContent || '').replace(/\s+/g, ' ').trim();

    if (text === '') {
        message.classList.remove(SUCCESS_CLASS);
        return;
    }

    if (message.classList.contains(SUCCESS_CLASS) && text === SUCCESS_TEXT) {
        return;
    }

    if (!isMaxReachedMessage(text)) {
        message.classList.remove(SUCCESS_CLASS);
        return;
    }

    message.textContent = SUCCESS_TEXT;
    message.classList.add(SUCCESS_CLASS);
}

/**
 * @param {ParentNode} root
 */
function scan(root) {
    const fields = [];

    if (root instanceof Element && root.matches(FIELD_SELECTOR)) {
        fields.push(root);
    }

    if (root.querySelectorAll) {
        root.querySelectorAll(FIELD_SELECTOR).forEach((field) => {
            fields.push(field);
        });
    }

    fields.forEach((field) => {
        field.querySelectorAll(MESSAGE_SELECTOR).forEach((message) => {
            rewriteMessage(message);
        });
    });
}

/**
 * @param {MutationRecord} mutation
 */
function handleMutation(mutation) {
    const nodes = [mutation.target, ...mutation.addedNodes];

    nodes.forEach((node) => {
        const message = messageFromNode(node);

        if (message) {
            rewriteMessage(message);
            return;
        }

        if (!(node instanceof Element)) {
            return;
        }

        if (node.matches(FIELD_SELECTOR) || node.querySelector(FIELD_SELECTOR)) {
            scan(node);
        }
    });
}

export function initGfFileLoadedNotice() {
    if (document.body.dataset.hfGfFileLoaded === '1') {
        return;
    }

    document.body.dataset.hfGfFileLoaded = '1';

    scan(document);

    const observer = new MutationObserver((mutations) => {
        mutations.forEach(handleMutation);
    });

    observer.observe(document.body, {
        childList: true,
        subtree: true,
        characterData: true,
    });

    document.addEventListener('gform_post_render', () => {
        scan(document);
    });

    if (window.jQuery) {
        window.jQuery(document).on('gform_post_render', () => {
            scan(document);
        });
    }
}
